import React, { useEffect } from "react";
import "./SuccessPage.scss";
import PartyPopper from "../../../../assets/svg/party-popper.svg";
import ModuleCard from "./ModuleCard";
import NavbarContainer from "../../../Navbar/NavbarContainer";
import PageAnalyticsIcon from "../../../../assets/svg/modules/page-analytics.svg";
import PublishIcon from "../../../../assets/svg/modules/publish.svg";
import ListeningIcon from "../../../../assets/svg/modules/listening.svg";
import ResponseIcon from "../../../../assets/svg/modules/response.svg";
import { useDispatch, useSelector } from "react-redux";
import { formatTokenLists, totalPlatformsConnected } from "../../../../actions/utils";
import { fetchTokenList } from "../../../../actions/tokensAction";
import { Redirect } from "react-router-dom";

const SuccessPage = (props) => {
    const { isMobile } = props;
    const dispatch = useDispatch();
    const sidebarExpanded = useSelector((state) => state.globalReducer.sidebarExpanded);

    useEffect(() => {
        dispatch(fetchTokenList());
    }, []);

    const tokenLists = useSelector((state) => state.tokensReducer.tokenList);
    const formattedTokenLists = formatTokenLists(tokenLists);
    // const totalCount = totalPlatformsConnected(formattedTokenLists);
    const listenPoints = (
        <ul className="list__content">
            <li className="list__items">Benchmark your performance and find new opportunities.</li>
            <li className="list__items">Track competitors.</li>
            <li className="list__items">Track every consumer trend and sentiment.</li>
            <li className="list__items">Turn online conversations into brand insights.</li>
        </ul>
    );
    const responsePoints = (
        <ul className="list__content">
            <li className="list__items">{`Smart Inbox that lets you view mentions, tags and DM's from your customers and others on social media.`}</li>
            <li className="list__items">Set up teams, agents and approval workflows</li>
            <li className="list__items">Auto-assign or manually assign tickets</li>
            <li className="list__items">{`View team and agent level SLA's and analytics`} </li>
        </ul>
    );
    const publishPoints = (
        <ul className="list__content">
            <li className="list__items">Create and publish content to several platforms including Facebook, X and Instagram.</li>{" "}
            {/*Changed Twitter name to X*/}
            <li className="list__items">Schedule content to be published later.</li>
            <li className="list__items">Set up approval workflows.</li>
            <li className="list__items">Store all your images and videos in the asset library to be used later.</li>
            <li className="list__items">View post analytics and get insights. </li>
        </ul>
    );
    const analyticsPoints = (
        <ul className="list__content">
            <li className="list__items"> Connect multiple profiles from Facebook, Instagram, X and other social networks.</li>
            <li className="list__items">View detailed insights on social profiles you manage.</li>
        </ul>
    );
    const pageDetails = [
        {
            icon: ListeningIcon,
            heading: "Listening",
            points: listenPoints,
            link: "/dashboard/all",
        },
        {
            icon: PublishIcon,
            heading: "Publishing",
            points: publishPoints,
            link: "/social-media-publishing/create-post",
        },
        {
            icon: ResponseIcon,
            heading: "Response",
            points: responsePoints,
            link: "/social-response/inbox",
        },
        {
            icon: PageAnalyticsIcon,
            heading: "Page Analytics",
            points: analyticsPoints,
            link: "/owned-page/",
        },
    ];
    return (
        <>
            {isMobile && <Redirect to="/signin-interstitial" />}
            <div className={`success__page__wrapper side ${sidebarExpanded ? "sidebar__expanded" : "sidebar__collapsed"}`}>
                <NavbarContainer history={props.history} location={props.location} />

                <div className="top__block">
                    <div className="heading__wrapper">
                        <h1 className="heading__text">Congratulations!!!</h1>
                        <img className="popper__img" alt="" src={PartyPopper} />
                    </div>

                    <p className="para__text">You are all set! Your free 7-day trial has started!</p>
                    {/* <br /> */}
                    <p className="para__text margin__top">Where do you want to go now?</p>
                </div>
                <div className="module__container">
                    {pageDetails.map((eachModule, idx) => (
                        <>
                            <ModuleCard key={idx} eachModule={eachModule} />
                        </>
                    ))}
                </div>
            </div>
        </>
    );
};

export default SuccessPage;
